import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Button from "../../components/button/Button";
// import Badge from "react-bootstrap/Badge";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { projectsHeader } from "../../portfolio.js";
import { projectcards } from "../../portfolio";
import { Card } from "react-bootstrap";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.orange }}
                >
                  {projectsHeader.title}
                </h1>
                <h2>( I Worked On )</h2>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.text }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        {projectcards.list.map((proj) => {
          return (
            <div className="repo-cards-div-main">
              <div>
                <h1>{proj.title}</h1>
                <h3>( {proj.subtitle} )</h3>
                <p>{proj.description}</p>
                <p>
                  <span className="project-role">My Role</span> {proj.role}
                </p>
                <p>
                  <span className="project-technology">Technology</span>{" "}
                  {proj.technology}
                </p>
                <p>
                  <span className="project-copyright">Worked At</span>{" "}
                  {proj.copyright}
                </p>
              </div>
              <Card className="h-100">
                <img
                  src={require(`../../assets/projects/${proj.img_path}`)}
                  alt=""
                />
              </Card>
            </div>
          );
        })}
        <Button
          text={"More Projects"}
          className="project-button"
          href="https://github.com/dev-lalitkumar"
          newTab={true}
          theme={theme}
        />
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
